import React from "react";
import styles from "./SpecsheetButtonWhite.module.css";

const SpecsheetButtonWhite = ({ children, handleClick, type }) => {
  return (
    <button className={styles.button} type={type} onClick={handleClick}>
      {children}
    </button>
  );
};

export default SpecsheetButtonWhite;
